import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule, Http } from '@angular/http';
import {LocationStrategy, PathLocationStrategy, APP_BASE_HREF, HashLocationStrategy} from '@angular/common'
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { IonicApp, IonicModule, IonicErrorHandler, Tabs } from 'ionic-angular';
import {IonTagsInputModule} from "ionic-tags-input";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TooltipsModule } from 'ionic-tooltips';
import { Storage, IonicStorageModule } from '@ionic/storage';

import { MyApp } from './app.component';

import { SignupPageModule } from '../pages/signup/signup.module';
import { ClientCreatePage } from '../pages/client-create/client-create';

import { Countries } from '../mocks/providers/countries';
import { Api } from '../providers/api';
import { Items } from '../providers/items';
import { User } from '../providers/user';
import { Clients } from '../providers/clients';
import { Assessments } from '../providers/assessments';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { IonicSelectableModule } from 'ionic-selectable';
// The translate loader needs to know where to load i18n files
// in Ionic's static asset pipeline.
export function HttpLoaderFactory(http: Http) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function provideSettings(storage: Storage) {
  /**
   * The Settings provider takes a set of default settings for your app.
   *
   * You can add new settings options at any time. Once the settings are saved,
   * these values will not overwrite the saved values (this can be done manually if desired).
   */
  // return new Settings(storage, {
  //   option1: true,
  //   option2: 'Ionitron J. Framework',
  //   option3: '3',
  //   option4: 'Hello'
  // });
}

@NgModule({
  declarations: [
    MyApp,
    ClientCreatePage,
  ],
  //imports are for modules. you need to add pages to declarations
  imports: [
    IonicSelectableModule,
    BrowserModule,
    HttpModule,
    IonTagsInputModule,
    BrowserAnimationsModule,
    TooltipsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [Http]
      }
    }),
    IonicModule.forRoot(MyApp,{tabsHideOnSubPages:false, tabsPlacement: 'top', tabsLayout:'icon-top'
    , locationStrategy:'path'
    , preloadModules: true
    , autocomplete: 'on'
  },
    ),
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    ClientCreatePage,
  ],
  providers: [
    Countries,
    Api,
    Items,
    User,
    Clients,
    Assessments,
    Tabs,
    // Keep this to enable Ionic's runtime error handling during development
    { provide: ErrorHandler, useClass: IonicErrorHandler,deps: [Storage] },
    {provide: LocationStrategy, useClass: PathLocationStrategy},
    {provide: APP_BASE_HREF, useValue : '/' }
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts